import { doc, getDoc } from "firebase/firestore";
import { useState } from "react";
import { db } from "../../firebase/firebase";
import { MailTemplateData } from "../../classes/mail.tsx";
import { ExpandableArea } from "../small-widgets";
import { Divider, useMediaQuery } from "@mui/material";
import { MessageDetails, TemplateDetails } from "./mail.tsx";
import LoadingBarApp from "../loading.jsx";
import { t } from "i18next";

export default function MailDetailsView({ mail }) {
    const [template, setTemplate] = useState(null);

    const isMobile = useMediaQuery("only screen and (max-width : 450px)");

    const [expandedTo, setExpandedTo] = useState(false);
    const [expandedAccepted, setExpandedAccepted] = useState(false);
    const [expandedPending, setExpandedPending] = useState(false);
    const [expandedRejected, setExpandedRejected] = useState(false);

    async function getTemplate() {
        var q = doc(db, 'email-templates', mail.getTemplate().getName());
        const templateData = await getDoc(q);
        const templeteD = MailTemplateData.fromJson(templateData.data());
        const templeteKeys = mail.getTemplate().getData();
        [...templeteKeys.keys()].map((key) => {
            templeteD.setHtml(templeteD.getHtml().replaceAll(`{{${key}}}`, templeteKeys.get(key)));
            templeteD.setSubject(templeteD.getSubject().replaceAll(`{{${key}}}`, templeteKeys.get(key)));
        })
        console.log(templeteD);
        setTemplate(templeteD);
    }

    if (mail.getTemplate() != null && mail.getTemplate() != undefined && template === null) {
        getTemplate();
    }

    return <div>
        {mail != null
            ? mail 
                ? <div style={{margin: 10}}>
                    <div className={isMobile ? "" : "expand-width"}>
                        <div>
                            <div className="mail-id">{mail.getId()}</div>
                            <div style={{fontSize: 8}}>{mail.getDelivery().getInfo().getMessageId()}</div>
                            <div style={{fontSize: 16}}>{mail.getDelivery().getState()}</div>
                        </div>
                        <div className="child-exp-all-width"/>
                        <div className="one-line" style={{fontSize: 13}}>
                            <div>{`${t('mails.details.started')}: ${mail.getDelivery().getStartTime().toDate().toLocaleString('es-ES')}`}</div>
                            <div>{`${t('mails.details.finished')}: ${mail.getDelivery().getEndTime().toDate().toLocaleString('es-ES')}`}</div>
                        </div>
                    </div>
                    <div style={{height: 10}}/>
                    <Divider orientation="horizontal" flexItem/>
                    <ExpandableArea expanded={expandedTo} setExpanded={setExpandedTo} title={t('mails.details.for')} margin={true}>
                        {mail.getTo().map((item, index) => <div key={index}>{item}</div>)}
                    </ExpandableArea>
                    <Divider orientation="horizontal" flexItem/>
                    <div style={{height: 10}}/>
                    <div>
                        {`${t('mails.details.attemps')}: ${mail.getDelivery().getAttemps()}`}
                    </div>
                    {mail.getDelivery().getError() != null && mail.getDelivery().getError() != undefined && mail.getDelivery().getError() != ""
                        ? <div className="expand-width">
                            <div>{t('mails.details.error')}: &nbsp;</div>
                            <div>{mail.getDelivery().getError()}</div>
                        </div>
                        : null
                    }
                    <div className="expand-width">
                        <div>{t('mails.details.response')}: &nbsp;</div>
                        <div>{mail.getDelivery().getInfo().getResponse()}</div>
                    </div>
                    <div style={{height: 10}}/>
                    <Divider orientation="horizontal" flexItem/>
                    {mail.getDelivery().getInfo().getAccepted().length != 0
                        ? <>
                            <ExpandableArea expanded={expandedAccepted} setExpanded={setExpandedAccepted} title={t('mails.details.accepted')} margin={true}>
                                {mail.getDelivery().getInfo().getAccepted().map((item, index) => <div key={index}>{item}</div>)}
                            </ExpandableArea>
                            <Divider orientation="horizontal" flexItem/>
                        </>
                        : null
                    }
                    {mail.getDelivery().getInfo().getPending().length != 0
                        ? <>
                            <ExpandableArea expanded={expandedPending} setExpanded={setExpandedPending} title={t('mails.details.pending')} margin={true}>
                                {mail.getDelivery().getInfo().getPending().map((item, index) => <div key={index}>{item}</div>)}
                            </ExpandableArea>
                            <Divider orientation="horizontal" flexItem/>
                        </>
                        : null
                    }
                    {mail.getDelivery().getInfo().getRejected().length != 0
                        ? <>
                            <ExpandableArea expanded={expandedRejected} setExpanded={setExpandedRejected} title={t('mails.details.rejected')} margin={true}>
                                {mail.getDelivery().getInfo().getRejected().map((item, index) => <div key={index}>{item}</div>)}
                            </ExpandableArea>
                            <Divider orientation="horizontal" flexItem/>
                        </>
                        : null
                    }
                    <div style={{height: 10}}/>
                    {mail.getTemplate() != null && mail.getTemplate() != undefined
                        ? <TemplateDetails template={mail.getTemplate()}/>
                        : null
                    }
                    {mail.getMessage() != null && mail.getMessage() != undefined
                        ? <MessageDetails message={mail.getMessage()}/>
                        : null
                    }
                    <div style={{height: 20}}/>
                    {mail.getTemplate() != null && mail.getTemplate() != undefined
                        ? <div>
                            <div style={{fontSize: 18, fontWeight: 600}}>{t('mails.details.completeMessage.title')}</div>
                            <Divider orientation="horizontal" flexItem/>
                            {template === null
                                ? <>
                                    <div style={{height: 3}}/>
                                    <LoadingBarApp/>
                                </>
                                : template === undefined
                                    ? <div className="expand-width" style={{alignItems: 'center'}}>
                                        <h1>{t('mails.details.completeMessage.notFound') + mail.getTemplate().getName()}</h1>
                                    </div>
                                    : <div>
                                        <div className="expand-width">
                                            <div style={{fontWeight: 600}}>{t('mails.details.completeMessage.subject')}: </div>
                                            <div style={{width: '5px'}}/>
                                            <div>{template.getSubject()}</div>
                                        </div>
                                        <div style={{height: 10}}/>
                                        <div style={{fontWeight: 600}}>{t('mails.details.completeMessage.text')}: </div>
                                        <div dangerouslySetInnerHTML={{__html: template.getHtml()}}></div>
                                    </div>
                            }   
                        </div>
                        : null
                    }
                </div> : null
            : <LoadingBarApp/>
        }
    </div>;
}